import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { FundDealSummaryRes } from '@dealstack/shared/lib/generated';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Button, Flex } from '@mantine/core';
import React from 'react';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const getFundLinkedDealsColumns = (
	tAdminDashboard: TranslateFunction<I18Namespaces.ADMIN_DASHBOARD>,
	actions?: {
		onUnlinkDeal?: (deal: FundDealSummaryRes) => void;
	}
): ExtendedColumnDef<FundDealSummaryRes>[] => {
	const columns: ExtendedColumnDef<FundDealSummaryRes>[] = [
		createTextColumn({
			headerText: tAdminDashboard('fund_settings.deals.table.headers.name'),
			columnLabel: tAdminDashboard('fund_settings.deals.table.headers.name'),
			filterText: tAdminDashboard('fund_settings.deals.table.filter.name'),
			id: 'name',
			showFilter: true,
			filterVariant: 'text',
		}),
		createTextColumn({
			headerText: tAdminDashboard('fund_settings.deals.table.headers.target_name'),
			columnLabel: tAdminDashboard('fund_settings.deals.table.headers.target_name'),
			filterText: tAdminDashboard('fund_settings.deals.table.filter.target_name'),
			id: 'targetName',
			showFilter: true,
			filterVariant: 'text',
		}),
	];

	if (actions?.onUnlinkDeal) {
		columns.push({
			header: '',
			id: 'actions',
			enableColumnFilter: false,
			enableGlobalFilter: false,
			enableSorting: false,
			cell: ({ row }) => (
				<Flex w="100%" align="center" justify="flex-end">
					<Button
						variant="subtle"
						color="red"
						data-testid={TEST_ELEMENT_IDS.FUND_DEALS_UNLINK_BUTTON}
						onClick={(e: React.MouseEvent) => {
							e.stopPropagation();
							actions.onUnlinkDeal!(row.original);
						}}
					>
						{tAdminDashboard('fund_settings.table.buttons.unlink_deal')}
					</Button>
				</Flex>
			),
		});
	}

	return columns;
};
